module.exports = __webpack_public_path__ + "static/media/3DPPA17.f70c7ce9.jpg";